import React, { useState } from 'react';

// Components
import { FontStyle } from './components';

// Pages
import { LoginPage } from './pages';

// Layouts
import { AdminLayout } from './layouts';

// Hooks
import { useTheme } from './hooks';

/**
 * Main Application Component
 * 
 * Mengatur state autentikasi dan tema aplikasi.
 * Menampilkan LoginPage jika belum login, atau AdminLayout jika sudah login.
 */
function App() {
    // Authentication state
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);

    // Theme hook
    const { isDarkMode, toggleTheme } = useTheme();

    // Auth handlers
    const handleLogin = () => setIsLoggedIn(true);
    const handleLogout = () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_info');
        setIsLoggedIn(false);
    };

    // Check session on mount
    React.useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            fetch('https://api.cloudnine.biz.id/check_auth.php', {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setIsLoggedIn(true);
                    } else {
                        localStorage.removeItem('auth_token');
                    }
                })
                .catch(() => localStorage.removeItem('auth_token'))
                .finally(() => setCheckingAuth(false));
        } else {
            setCheckingAuth(false);
        }
    }, []);

    if (checkingAuth) {
        return (
            <div className={`flex h-screen items-center justify-center ${isDarkMode ? 'bg-slate-900' : 'bg-white'}`}>
                <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    return (
        <div className={isDarkMode ? 'dark' : ''}>
            {/* Global Font & Animation Styles */}
            <FontStyle />

            {/* Conditional Rendering based on Auth State */}
            {isLoggedIn ? (
                <AdminLayout
                    onLogout={handleLogout}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                />
            ) : (
                <LoginPage
                    onLogin={handleLogin}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                />
            )}
        </div>
    );
}

export default App;